// src/components/coins/LowClassBank.js — teacher banner when the class coin
// bank drops below 100. Shown only once the bank has been bought into or has
// built up 100+ from daily visits.
import React from "react";
import { useWallet } from "../../services/coinService";
import BuyCoinsButton from "./BuyCoinsButton";
import "./coinStore.css";

const LOW = 100;

const LowClassBank = () => {
  const w = useWallet();
  if (!w.loaded || !w.hasClassBank || !w.bankWasBig || w.classBank >= LOW) return null;
  return (
    <div className="sbl-bank-low" role="status">
      <span>🪙 Your class coin bank is low — {w.classBank} coin{w.classBank === 1 ? "" : "s"} left.</span>
      <BuyCoinsButton educator label="Top up" />
    </div>
  );
};

export default LowClassBank;
